import script from "./UserMenu.vue?vue&type=script&setup=true&lang=js"
export * from "./UserMenu.vue?vue&type=script&setup=true&lang=js"

import "./UserMenu.vue?vue&type=style&index=0&id=31d95b51&lang=scss&scoped=true"

import exportComponent from "/vue-ui/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-31d95b51"]])

export default __exports__